export const GeneLifeDict = {
    'ja-JP': {
        'Login to GeneLife': "GeneLifeログイン",
        'Sign In': "ログイン",
        'sign Up': "サインアップ",
        'Username': "メールアドレス",
        'Email': "登録メールアドレス",
        'Enter your username': "　",
        'Password': "パスワード",
        'Confirm Password': "確認用パスワード",
        'Enter your password': "",
        'Forget your password? ': "パスワードをお忘れの方",
        'No account? ': "アカウントがありませんか？",
        'Create account': "GeneLifeアカウントを作成",
        'coustome sign up':'新規登録（会員情報）の手続き',
        'Reset password': "パスワード変更画面",
        'Create Account':'登録する',
        'Send verification code your box for change your password': "登録メールアドレス宛にパスワード変更に必要な認証コードをお送りします。",
        'Please check the authorization code sent to your registered email address':"会員登録時に使用したメールアドレスを下記の欄に御入力ください。",
        'Reason to your registered email address' : 'ご本人様であることを確認するため、メールアドレスに認証コードを送信いたします。',
        'Purpose to your registered email address' : '登録されているパスワードを変更する上で、',
        'Explanation to change your password' : '※認証コードと新しいパスワードをご入力ください。認証コードが確認出来ない場合は、迷惑メールフォルダのご確認や再発行をしてください。',
        'Attention to enter authorization code' : '※登録メールアドレス宛に届いている認証コードをご入力ください。',
        'Password must be at least 8 characters long upper case letters, lower case letters, half size numbers must be at least 1 character each':"※パスワードは 8文字以上（大文字英字A~Z、小文字英字a~z、数字0~9をそれぞれ最低 1文字以上をご使用ください）",
        'Hint authorization code in Confirm SignUp screen': "※上記のメールアドレスに届いている認証コードをご入力ください。",
        'Hint authorization code in Confirm Change Email screen': "※認証コードをご入力ください。",
        'Back to Sign In': "ログイン画面へ戻る",
        'Back to Sign In Toregist': "次の画面に進む：こちらをクリックしてください。（GeneLife会員の方 ログイン画面）",
        'Send Code': "送信する",
        'Code': "認証コード",
        'New Password': "新しいパスワード",
        'Resend Code': "認証コードを再送する",
        'Submit': "変更する",
        'Confirm': "認証する",
        'Password Update Complete': "パスワードが変更されました",
        'Please login again': " ログインし直してください。 ",
        'WGS Please login again': " お手続きが途中です。「GeneLife会員の方」より遺伝子検査にログインし「新たにIDを登録する」にお進みください。",
        'Confirm registered Email': "登録メールアドレス確認",
        'Nickname': "ログインID",
        'Check Account': "確認する",
        'Change Email complete': "メールアドレスを変更しました",
        'Back and login via new Email': "ログイン画面へ戻り、新しいメールアドレスでログインしてください",
        'Go to Login': "ログイン画面へ",
        'Confrim account completed': "登録情報確認が完了しました",
        'Move to Login': "ログイン画面に遷移し直してください",
        'Transition error': "セッションエラー",
        'Please back login screen': "ログインし直してください",
        'Send Mail': "メール送信完了",
        'Please check email': "メールをご確認ください。",
        'Verification email sent': "登録メールアドレスへ認証コードをお送りしました。ご確認ください。",
        'Press link url in mail': "メールにあるURLをクリックして、パスワードの変更をお願いいたします。",
        'Transfer to Confirm Sign Up Screen': "ログインページへ",
        'Confirm SignUp Complete': "ユーザ情報登録が完了しました",
        'WGS Confirm SignUp Complete': "認証に成功し、ログイン可能となりました。検査ID登録にお進みください。",
        'Email Update Complete': "メールアドレスの変更が完了しました",
        'User Info Update Complete': "ユーザ情報の変更が完了しました",
        'Back to MyPage Message': "再度マイページへお戻りください",
        'Back to MyPage': "マイページへ戻る",
        'Custom Confirm Sign Up': "登録情報確認",
        'Confirm Change Email': "認証コード入力画面",
        'Sign up': "新規会員登録",
    }
}
